import React, {Component} from 'react'
import JobsGeneratedPage from './JobsGeneratedPage'
import {Link} from "react-router-dom"
import {Icon} from "antd"
import './../styles/_index.scss'

class JobsGeneratedContainer extends Component {

    render() {
        return (
            <div>
                <div className='container-fluid min-vh-100'>
                    <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                        <div className='mb-3'>
                            <Link to={'/re-generate'}><Icon type="double-left" className='mr-2'/>Trang generate lại file in</Link>
                        </div>
                        <h3 className="mb-3">Danh sách generate lại file in</h3>
                        <JobsGeneratedPage/>
                    </div>
                </div>
            </div>
        )
    }

}

export default JobsGeneratedContainer